'use client'

import { twMerge } from '@/lib/classname/twMerge'
import type { ResponsiveProp } from '@/lib/device/useBreakpoint'
import { useResponsiveProp } from '@/lib/device/useBreakpoint'
import { BaseSkeleton } from './BaseSkeleton'

export type ButtonSkeletonSize = 'sm' | 'md' | 'lg'

export const SKELETON_BUTTON_SIZE: Record<ButtonSkeletonSize, string> = {
  sm: 'h-4',
  md: 'h-5',
  lg: 'h-6',
} as const

const SKELETON_BUTTON_ROUND: Record<ButtonSkeletonSize, string> = {
  sm: 'size-4 max-h-4 max-w-4',
  md: 'size-5 max-h-5 max-w-5',
  lg: 'size-6 max-h-6 max-w-6',
} as const

export type SkeletonButtonProps = {
  className?: string
  size: ResponsiveProp<ButtonSkeletonSize>
  isRound: ResponsiveProp<boolean>
}

export function ButtonSkeleton({ className, size, isRound }: SkeletonButtonProps) {
  const responsiveSize = useResponsiveProp(size)
  const responsiveIsRound = useResponsiveProp(isRound)

  return (
    <BaseSkeleton
      className={twMerge(
        'rounded-full',
        className,
        !responsiveIsRound && SKELETON_BUTTON_SIZE[responsiveSize],
        responsiveIsRound && 'aspect-square shrink-0 grow-0',
        responsiveIsRound && SKELETON_BUTTON_ROUND[responsiveSize],
      )}
    />
  )
}
